// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui.modal .PrHsy{align-items:center;display:flex;gap:2rem;justify-content:space-between;min-width:0}.ui.modal .PrHsy h2{font-size:1.6rem;margin:0}.ui.modal .PrHsy .g7XHe{align-items:center;display:flex;flex:1 1 auto;font-size:2rem;gap:.75rem;min-width:0}.ui.modal .PrHsy .g7XHe .content{flex:1 1 auto;min-width:0}.ui.modal .PrHsy .bXqir{display:block;min-width:0}.ui.modal .PrHsy .NMBF5{flex-shrink:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `PrHsy`,
	"titleBlock": `g7XHe`,
	"subtitle": `bXqir`,
	"extra": `NMBF5`
};
module.exports = ___CSS_LOADER_EXPORT___;
